import script from "./GiftPackagingDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiftPackagingDetails.vue?vue&type=script&lang=ts&setup=true"

import "./GiftPackagingDetails.vue?vue&type=style&index=0&id=49361bc3&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49361bc3"]])

export default __exports__